import { render } from "./BaseTableComponent.vue?vue&type=template&id=d65acda0"
import script from "./BaseTableComponent.vue?vue&type=script&lang=ts"
export * from "./BaseTableComponent.vue?vue&type=script&lang=ts"

import "./BaseTableComponent.vue?vue&type=style&index=0&id=d65acda0&lang=scss"
script.render = render

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTd,QBtn,QField});
